import React, {useContext, useState, useEffect} from "react";
import FadeIn from "../../components/fadeIn/FadeIn";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {illustration, greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    fetch("/profile.json")
      .then(res => (res.ok ? res.json() : Promise.reject(res)))
      .then(data => setAvatarUrl(data.data.user.avatarUrl))
      .catch(() => setAvatarUrl(null));
  }, []);

  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <FadeIn distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {greeting.title}
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />
                {greeting.resumeLink && (
                  <a
                    href={require("./resume.pdf")}
                    download="Resume.pdf"
                    className="download-link-button"
                  >
                    <Button text="Download my resume" />
                  </a>
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="headshot"
                src={avatarUrl || require("../../assets/images/headshot.png")}
              ></img>
            )}
          </div>
        </div>
      </div>
    </FadeIn>
  );
}
